import { App } from "./typings/App";
import { configs as configWMS } from "./wms/src/index";

export const apps: App[] = [configWMS()];
